var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"element",attrs:{"role":_vm.disable ? undefined : 'button'},on:{"click":_vm.invokeCopy}},[_vm._t("default"),_vm._v(" "),_c('input',{ref:"copy",attrs:{"type":"hidden"}})],2)}
var staticRenderFns = []

export { render, staticRenderFns }